import Cookie from 'js-cookie'
import { parse } from 'querystringify'

// Types
import { APIAction, Dispatch, GetState } from 'types'

export const actions = {
  fetchUserCountry: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_USER_COUNTRY',
      method: 'GET',
      endpoint: '/geo-ip',
    },
  }),

  fetchCodeInfo: (cookieCode: string | undefined, urlCode: string | undefined) => async (dispatch: Dispatch, getState: GetState) => {
    let selectedRefCode = 'default'

    await Promise.all([
      ...(cookieCode ? [dispatch(actions.fetchInfoForCode(cookieCode))] : []),
      ...(urlCode ? [dispatch(actions.fetchInfoForCode(urlCode))] : []),
      dispatch(actions.fetchInfoForCode('default')),
    ])

    const codeInfo = getState().signup.signupCodeInfo[urlCode as string]
    if (codeInfo?.refcodevalid) {
      selectedRefCode = codeInfo.refcode
    } else {
      const cookieCodeInfo = getState().signup.signupCodeInfo[cookieCode as string]
      if (cookieCodeInfo?.refcodevalid) {
        selectedRefCode = cookieCodeInfo.refcode
      }
    }

    dispatch({ type: 'SELECT_REF_CODE', data: selectedRefCode })
  },

  storeRefCodeInCookie: () => (dispatch: Dispatch, getState: GetState) => {
    const { code } = parse(getState().router.location.search) as { code: string }
    const urlCodeInfo = getState().signup.signupCodeInfo[code]
    if (urlCodeInfo?.refcodevalid && !urlCodeInfo.force_signup_code) {
      Cookie.set('refcode', code)
    } else {
      const cookieCodeInfo = getState().signup.signupCodeInfo[Cookie.get('refcode') as string]
      if (!cookieCodeInfo?.refcodevalid) {
        Cookie.remove('refcode')
      }
    }
  },

  fetchInfoForCode: (code: string): APIAction => ({
    CALL_API: {
      type: 'FETCH_INFO_FOR_CODE',
      method: 'GET',
      endpoint: `/api/referral/?code=${code}`,
      actionParams: { code },
      requestKey: code,
    },
  }),
}
